const data = {
  head: {
    title: 'Aktuelle Stellenangebote bei audibene',
    description:
      'Unsere Vision ist es, Menschen weltweit zu besserem Hören zu verhelfen. Werde Teil unseres bunten Teams und mache die Welt ein bisschen glücklicher.',
    favicon: 'favicon-de.ico'
  },
  benefits: {
    title: 'Benefits',
    items: [
      {
        title: 'Growth',
        icon: 'de/Benefits/Benefit_Growth.png',
        text:
          'Wir glauben: Menschen sind im Job am glücklichsten, wenn sie genügend Freiraum zur Selbstverwirklichung haben. Regelmäßige One-on-Ones und gezielte Growth Sessions unterstützen deine Weiterentwicklung – für dein volles Potenzial und deine beruflichen Ziele.'
      },
      {
        title: 'Health',
        icon: 'de/Benefits/Benefit_Health.png',
        text:
          'Zusätzlich zur Urban Sports Club-Mitgliedschaft erholst du dich bei entspannten Rooftop-Yoga-Sessions und tauschst dich bei gemeinsamen Lunches mit Kolleg:innen aus. Getränke und Kaffee stehen dir jederzeit zur Verfügung. So sorgen wir für dein Wohlbefinden.'
      },
      {
        title: 'Team',
        icon: 'de/Benefits/Benefit_Team.png',
        text:
          'Ein starkes Teamgefühl ist uns wichtig. Regelmäßige Team-Events, Offsites und Peer Clubs stärken den Zusammenhalt und schaffen eine angenehme Atmosphäre. Zudem unterstützen wir dich mit dem Deutschlandticket, um den regelmäßigen Austausch im Büro zu fördern.'
      },
      {
        title: 'Impact',
        icon: 'de/Benefits/Benefit_Impact.png',
        text:
          'Dein Beitrag zählt – wir fördern eine Kultur, in der jede Stimme gehört wird und neue Ansätze willkommen sind. Wir sind überzeugt, dass Innovation aus der Vielfalt unserer Teams entsteht, mit der wir gemeinsam die Zukunft der Hörversorgung gestalten.'
      }
    ]
  },
  trustwidgets: {
    items: [
      {
        url:
          'https://kununu.com/de/audibene1?rfr=affiliate_widget&utm_content=widget_icon_text_small&utm_medium=affiliate&utm_source=widget',
        imgSrc: 'de/Trust/kununu-widget-icon.svg',
        imgTitle: 'kununu'
      },
      {
        url: 'https://www.glassdoor.de/Überblick/Arbeit-bei-audibene-EI_IE1155737.11,19.htm',
        imgSrc: 'de/Awards/glassdoor_de.png',
        imgTitle: 'glassdoor'
      }
    ]
  },
  awards: {
    items: [
      {
        icon: 'de/Awards/kununu-open-company_de.png'
      },
      {
        icon: 'de/Awards/kununu-top-company_de.png'
      },
      {
        icon: 'de/Awards/kununu-Top-Company-Siegel 2023.png'
      }
    ]
  },
  carousel: {
    slides: [
      {
        img: {
          mobile: 'de/Carousel/miracle_m.jpg',
          desktop: 'de/Carousel/miracle.jpg'
        },
        title: 'Vom Berliner Start-up zu einem der führenden Akustiker weltweit',
        text:
          'Wir sind der am schnellsten wachsende Hörgeräte-Akustiker, den es je gab. Nach kurzer Zeit haben wir uns von Berlin aus auf zwei weitere Kontinente ausgebreitet. Heute haben wir Büros in Berlin, Mainz, Marseille, Rotkreuz, Utrecht, Neu-Delhi, Denver, Miami, Kapstadt und Seoul.'
      },
      {
        img: {
          mobile: 'de/Carousel/marco_and_paul_m.jpg',
          desktop: 'de/Carousel/marco_and_paul.jpg'
        },
        title: 'Eine Vision wird geboren',
        text:
          'Unsere Gründer Dr. Marco Vietor und Paul Crusius kennen sich schon aus der Uni. Gemeinsam hatten sie die Idee, mit Vorurteilen gegenüber Hörgeräten aufzuräumen und Menschen auf ganz moderne und einfache Weise zu besserem Hören – und damit zu mehr Lebensqualität – zu verhelfen.'
      },
      {
        img: {
          mobile: 'de/Carousel/wohnzimmer_m.jpg',
          desktop: 'de/Carousel/wohnzimmer.jpg'
        },
        title: 'Alles begann in diesem Wohnzimmer',
        text:
          '2012 starteten Marco, Paul und 3 weitere Kolleg:innen mit dem audibene Geschäftsmodell. Die ersten telefonischen Beratungsgespräche fanden noch im Wohnzimmer von Marco statt. Ohne Schreibtische und mit nur einer Telefonleitung.'
      },
      {
        img: {
          mobile: 'de/Carousel/koepenicker_m.jpg',
          desktop: 'de/Carousel/koepenicker.jpg'
        },
        title: 'Das erste Büro',
        text:
          'Drei Monate später bezogen sie das erste offizielle audibene Büro in Berlin Kreuzberg: Schreibtische für alle und jede Menge Platz. Ab jetzt wurden täglich immer mehr Menschen hörglücklich gemacht und das Team wuchs so stark weiter, dass es auch hier bald deutlich zu eng wurde.'
      },
      {
        img: {
          mobile: 'de/Carousel/zaudibene_m.jpg',
          desktop: 'de/Carousel/zaudibene.jpg'
        },
        title: 'Aus klein wird groß',
        text:
          'Zwei weitere Umzüge und etlichen Zuwachs an Kolleg:innen später findet man das audibene Headquarter heute mit rund 220 Mitarbeiter:innen in Berlin Prenzlauer Berg sowie einen weiteren Firmensitz in Mainz. Eine gewisse Wohnzimmer-Dynamik soll beibehalten werden: Marco und Paul haben keine eigenen Büros, sondern sitzen zwischen uns allen.'
      },
      {
        img: {
          mobile: 'de/Carousel/us-office_m.jpg',
          desktop: 'de/Carousel/us-office.jpg'
        },
        title: 'Höher, schneller, weiter',
        text:
          'Die Vision unserer Gründer fand Anklang. Und das nicht nur in Deutschland - auch in weiteren Teilen Europas, in Nordamerika, in Asien und in Afrika möchten Menschen ihr Leben mit audibene verbessern. Heute sorgen Marco und Paul mit rund 1.200 Kolleg:innen aus 45 Nationen für gutes und einfaches Hören in 8 Ländern der Welt. Weitere Märkte nicht ausgeschlossen.'
      }
    ]
  },
  development: {
    title: 'Lerne unser Team kennen',
    items: [
      {
        img: 'de/Development/portrait_01.jpg',
        innerTitle: 'Christina',
        innerSubtitle: 'Senior Team Lead Customer Sales Consulting',
        innerCopy:
          '„Ich kam 2015 als Kundenberaterin zu audibene nach Berlin. Inzwischen bin ich wieder in meine geliebte Heimat zurückgezogen und leite hier eins unserer Kundenberater-Teams im schönen Mainz am Rhein.“'
      },
      {
        img: 'de/Development/portrait_02.jpg',
        innerTitle: 'Gui',
        innerSubtitle: 'Senior Platform Engineer',
        innerCopy:
          '„Was mir an der Arbeit bei audibene Spaß macht, sind meine Kollegen und wie offen und freundlich sie sind. Mein Team ist sehr erfahren. Ich genieße die herausfordernden und dynamischen Diskussionen, die wir führen."'
      },
      {
        img: 'de/Development/portrait_03.jpg',
        innerTitle: 'Sabine',
        innerSubtitle: 'Senior Business Development Manager',
        innerCopy:
          '„Ich bin 2020 bei audibene in der Talent Acquisition gestartet und hatte dort eine tolle Zeit, in der ich viel gelernt habe. Als ich nach 3 Jahren bereit für eine neue Challenge war, wurde mir die Möglichkeit geboten, an einem spannenden neuen Projekt teilzuhaben - seitdem unterstütze ich im Business Development und kann gemeinsam mit audibene wachsen.“'
      }
    ]
  },
  footer: {
    social: [
      {
        title: 'LinkedIn',
        icon: 'linkedin.svg',
        url:
          'https://www.linkedin.com/company/audibene?utm_source=Career%20Website&utm_medium=Icon&utm_campaign=Employer%20Branding'
      },
      {
        title: 'Xing',
        icon: 'xing.svg',
        url:
          'https://www.xing.com/pages/audibene?utm_source=Career%20Website&utm_medium=Icon&utm_campaign=Employer%20Branding'
      },
      {
        title: 'Instagram',
        icon: 'instagram.svg',
        url:
          'https://www.instagram.com/weareaudibene/?utm_source=Career%20Website&utm_medium=Icon&utm_campaign=Employer%20Branding'
      },
      {
        title: 'youtube',
        icon: 'youtube.svg',
        url: 'https://www.youtube.com/channel/UCgxXCeJf-rlwNQK73J2nyPw'
      },
      {
        title: 'Blog',
        icon: 'blog.svg',
        url:
          'https://inside.audibene.de/?utm_source=Career%20Website&utm_medium=Icon&utm_campaign=Employer%20Branding'
      }
    ],
    international: {
      title: 'audibene/hear.com international:',
      links: [
        {
          title: 'Netherlands',
          icon: 'flag_netherlands@2x.png',
          url: 'https://www.audibene.nl'
        },
        {
          title: 'Switzerland',
          icon: 'flag_switzerland@2x.png',
          url: 'https://www.audibene.ch'
        },
        {
          title: 'Canada',
          icon: 'flag_canada@2x.png',
          url: 'https://www.hear.com/ca'
        },
        {
          title: 'France',
          icon: 'flag_france@2x.png',
          url: 'https://www.audibene.fr/'
        },
        {
          title: 'USA',
          icon: 'flag_usa@2x.png',
          url: 'https://www.hear.com/'
        },
        {
          title: 'India',
          icon: 'IN_flag@2x.png',
          url: 'https://www.hear.com/in'
        },
        {
          title: 'Malaysia',
          icon: 'flag_malaysia@2x.png',
          url: 'https://www.hear.com/my'
        },
        {
          title: 'Germany',
          icon: 'flag_germany@2x.png',
          url: 'https://www.audibene.de/'
        },
        {
          title: 'South Korea',
          icon: 'flag_south_korea@2x.png',
          url: 'https://www.hear.com/kr'
        }
      ]
    },
    nav: [
      {
        title: 'Impressum',
        url: 'https://www.audibene.de/impressum/'
      },
      {
        title: 'AGB',
        url: 'https://www.audibene.de/agb-datenschutz/'
      },
      {
        title: 'Datenschutz',
        url: 'https://www.audibene.de/datenschutz/'
      },
      {
        title: 'Presse',
        url: 'https://www.audibene.de/presse/'
      }
    ]
  },
  header: {
    url: 'https://www.audibene.de/',
    logo: process.env.PUBLIC_URL + '/Assets/de/Header/audibene-logo.svg',
    items: [
      {
        text: 'Das sind wir',
        anchor: 'who'
      },
      {
        text: 'Benefits',
        anchor: 'benefits'
      },
      {
        text: 'Jobs',
        anchor: 'jobs'
      }
    ]
  },
  hero: {
    img: {
      mobile: 'de/Hero/new_header_photo_05_2025.jpg',
      desktop: 'de/Hero/new_header_photo_05_2025.jpg'
    },
    title: 'Jobs bei audibene',
    subtitle: 'Wir lassen Menschen besser hören.',
    cta: {
      text: 'Finde deinen Job',
      anchor: 'jobs'
    }
  },
  jobs: {
    title: 'Bewirb dich jetzt!'
  },
  offices: {
    title: {
      mobile: 'Standorte Deutschland',
      desktop: 'Standorte Deutschland'
    },
    items: [
      [
        {
          block: 'image',
          img: 'de/Offices/o_01.jpg'
        },
        {
          block: 'text',
          title: 'Berlin',
          text:
            'In unserem Headquarter in Berlin erwarten dich ca. 220 Kolleg:innen, 7 freundliche Hunde und 200m² Dachterrasse. Auf 4 Etagen mit Loft-Charakter sorgen wir vom Prenzlauer Berg aus weltweit für gutes Hören. Hier ist der Ort, an dem die Marketing-Fäden all unserer Büros zusammenlaufen.'
        },
        {
          block: 'image',
          img: 'de/Offices/o_02.jpg'
        }
      ],
      [
        {
          block: 'image',
          img: 'de/Offices/o_03.jpg'
        },
        {
          block: 'image',
          img: 'de/Offices/o_04.jpg'
        },
        {
          block: 'text',
          title: 'Mainz',
          text:
            'Im RheinCampus in Mainz vereinen wir unser internationales Schulungszentrum für unsere Hörberater:innen und ein Hörakustik-Studio mit modernster Technik. Zudem bieten wir hier Büroräume für unsere Kolleg:innen in und um Mainz. All dies mit direktem Blick auf den wunderschönen Rhein.'
        }
      ],
      [
        {
          block: 'text',
          title: 'Dein Home Office',
          titleMobile: 'Dein Home Office',
          text:
            'Zu Hause ist\'s doch am schönsten? Im Sales kannst du deutschlandweit aus dem Home Office arbeiten – überall dort, wo wir keinen Standort in deiner Nähe haben. Dank modernster Video-Kommunikationstechnik bist du bequem bei dir zu Hause und deinen Kolleg:innen trotzdem ganz nah.'
        },
        {
          block: 'image',
          img: 'de/Offices/o_05.jpg'
        },
        {
          block: 'image',
          img: 'de/Offices/o_06.jpg'
        }
      ]
    ],
    single: {
      title: 'Wähle dein Traum-Büro',
      text:
        'Wir bieten dir die Möglichkeit, deutschlandweit mit uns zu arbeiten. Du entscheidest dich zwischen: Großstadtluft in unserem loftartigen Headquarter in Berlin, Blick auf den Rhein in unserem Office im idyllischen Mainz oder deinen ganz eigenen vier Wänden bei dir zu Hause.'
    }
  },
  values: {
    title: 'Unsere Werte',
    items: [
      {
        title: 'Menschen helfen',
        icon: 'de/Values/change-lives.svg',
        text: 'Wir verändern das Leben der Menschen durch besseres Hören. Das treibt uns an.'
      },
      {
        title: 'Gemeinsam als Team',
        icon: 'de/Values/one-team.svg',
        text: 'Wir arbeiten gerne zusammen und lieben es unsere Erfolge gemeinsam zu feiern. '
      },
      {
        title: 'Ideen umsetzen',
        icon: 'de/Values/entrepreneurs.svg',
        text: 'Wir sind Unternehmer. Wir handeln schnell und gehen auch mal Risiken ein.'
      },
      {
        title: 'Wachstum',
        icon: 'de/Values/growth.svg',
        text: 'Wir legen Wert auf Wachstum: Persönliches, Team- und Kundenwachstum.'
      },
      {
        title: 'Verantwortung',
        icon: 'de/Values/responsibility.svg',
        text: 'Du hast die Verantwortung. Wir haben kein Organigramm.'
      }
    ]
  },
  who: {
    title: 'Das sind wir',
    text:
      'Unsere Vision ist es, Menschen weltweit zu besserem Hören zu verhelfen. Dank modernster Technik in nahezu unsichtbarem Design muss heute niemand mehr mit schlechtem Hören leben. Werde Teil unseres bunten Teams und mache die Welt ein bisschen glücklicher.',
    success: {
      title: 'Unsere Erfolgsgeschichte',
      items: [
        {
          number: '2012',
          text: 'Gründung'
        },
        {
          number: '8',
          text: 'Länder'
        },
        {
          number: '1.200',
          text: 'Kolleg:innen'
        },
        {
          number: '45',
          text: 'Nationen'
        }
      ]
    }
  },
  work: {
    title: 'Wie wir arbeiten',
    blocks: [
      {
        img: {
          desktop: 'de/Work/presentation.jpg',
          mobile: 'de/Work/presentation-mobile.jpg'
        },
        textBlock: {
          title: 'One team, one dream',
          text:
            'Wir arbeiten teamübergreifend an Projekten und denken nicht in Abteilungen. Hierarchien spielen bei uns kaum eine Rolle. Stattdessen kommunizieren wir auf Augenhöhe und schätzen jede Meinung – egal, ob von Praktikant:innen oder von Teamleiter:innen.'
        }
      }
    ]
  },
  video: {
    videoLink:
      'https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/careers-site/video/Audibene_GmbH_-_Imagefilm.mp4',
    playImg: 'de/Video/play.svg',
    coverImg: 'de/Video/video-2023-cover.jpg'
  },
  // sales page
  salesHero: {
    img: {
      mobile: 'de/Hero/hero-audibene-de-sales.jpg',
      desktop: 'de/Hero/hero-audibene-de-sales.jpg'
    },
    title: 'Finde deinen Traumjob',
    subtitle: 'In unserem Sales Team.',
    cta: {
      text: 'Jetzt bewerben!',
      link: 'https://boards.greenhouse.io/audibenehearcom/jobs/2205293'
    }
  },
  // sales campaign page
  salesCampaignHero: {
    img: {
      mobile: 'de/Hero/hero-audibene-de-sales.jpg',
      desktop: 'de/Hero/hero-audibene-de-sales.jpg'
    },
    title: 'Finde deinen Traumjob',
    subtitle: 'In unserem Sales Team.',
    cta: {
      text: 'Jetzt bewerben!',
      link: 'https://boards.greenhouse.io/audibenehearcom/jobs/4706391'
    }
  },
  whatAwaits: {
    title: 'Das erwartet dich bei audibene:',
    items: [
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-1.svg',
        text: 'Viele Kund:innen, die du jeden Tag mit gutem Hören glücklich machst.'
      },
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-2.svg',
        text: 'Ein hochmodernes Arbeitsumfeld im Home Office oder Büro.'
      },
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-3.svg',
        text: 'Tolle Kolleg:innen in einer familiären Arbeitsatmosphäre.'
      },
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-4.svg',
        text: 'Ein attraktives, leistungsorientiertes Gehalts- und Provisionsmodell.'
      },
      {
        icon: 'de/Sales/WhatAwaits/ico-intro-5.svg',
        text: 'Aktive Weiterentwicklung mit Trainings und Coachings.'
      }
    ]
  },
  salesJob: {
    title: 'Der Job im Sales Team bei audibene',
    blocks: [
      {
        img: {
          desktop: 'de/SalesJob/mainz-consultant_desktop.jpg',
          mobile: 'de/SalesJob/mainz-consultant_mobile.jpg'
        },
        textBlock: {
          text:
            'Der Job als Sales Consultant bei uns ist vielfältig. Direkt beim Start erhältst du warme Kontakte von Menschen, die sich auf unserer Website angemeldet haben. Von da an begleitest du sie auf dem Weg zu besserem Hören und mehr Lebensqualität – vom ersten Kontakt bis hin zum Abschluss. Inhaltlich bist du dafür verantwortlich, Kund:innen am Telefon oder über Video zu beraten, sie zum Testen von Hörgeräten zu motivieren und den Verkauf abzuschließen. Unsere größte Zielgruppe, die Babyboomer, ist dabei anspruchsvoll und erwartet eine kompetente und einfühlsame Beratung.'
        }
      },
      {
        img: {
          desktop: 'de/SalesJob/berlin-consultant_desktop.jpg',
          mobile: 'de/SalesJob/berlin-consultant_mobile.jpg'
        },
        textBlock: {
          text:
            'Nachdem du im Erstgespräch Termine vereinbart hast, organisierst du deine eigene Pipeline und arbeitest auf dein Umsatzziel hin. Deinen Arbeitsalltag bestimmst du dabei selbständig. Während des gesamten Prozesses kommunizierst du sowohl mit deinen Kund:innen als auch mit den entsprechenden Partnerakustiker:innen. So stellst du sicher, dass du die optimale Lösung findest.'
        }
      }
    ]
  },
  audibeneModel: {
    title: 'Das weltweit einzigartige audibene Modell: Zwei Wege zum perfekten Hörgerät',
    items: [
      {
        icon: {
          color: '#A0CFEB'
        },
        text:
          'Über konsequentes Online-Marketing erreichen wir gezielt moderne, aktive Menschen mit Hörproblemen – und motivieren sie, sich zum kostenlosen Testen von Mini-Hörgeräten auf unserer Website anzumelden. Mehrere tausend neue Kund:innen registrieren sich auf diese Weise jede Woche bei uns!'
      },
      {
        icon: {
          color: '#6AADE4'
        },
        text:
          'Nach der Registrierung meldet sich ein Sales Consultant aus unserem Team telefonisch oder per Video-Call. In dieser Erstberatung werden alle Fragen rund um das Thema Hörgeräte geklärt, eine Bedarfsanalyse durchgeführt und ein Termin zur Anpassung vereinbart.'
      },
      {
        icon: {
          color: '#00549F'
        },
        text:
          'Bei der Anpassung wird ein exakter Hörtest durchgeführt und ein geeignetes Hörgeräte-Modell zum Probetragen eingestellt – entweder klassisch in einem unserer Partner-Akustikgeschäfte oder digital per Video-Call. Für den digitalen Weg schicken wir unsere HörErlebnisBox nach Hause: mit Hörgerät und der nötigen Technik für den Termin. So erreichen wir Menschen auch dort, wo kein Fachgeschäft in der Nähe ist.'
      },
      {
        icon: {
          color: '#21314D'
        },
        text:
          'Jetzt können unsere Kund:innen die Hörgeräte über 4 Wochen im Alltag testen. Dabei werden sie regelmäßig von uns kontaktiert und beraten, bei Bedarf wird das Modell gewechselt oder weiter angepasst. Diese „beidseitige“ Expert:innenberatung führt schneller und effizienter zum Hör-Erfolg als bei anderen Hörakustiker:innen.'
      },
      {
        icon: {
          color: '#FFA100'
        },
        text:
          'Sobald das perfekte Hörgerät gefunden ist, schließt der Sales Consultant den Verkauf ab.'
      }
    ]
  },
  apply: {
    title: 'Bewerben bei audibene: In nur 5 Schritten zum Traumjob',
    text:
      'Unser Ziel ist es, die besten Sales Consultants in ganz Deutschland zu finden! Deshalb nehmen wir uns viel Zeit für dich und deine Bewerbung. Du bekommst bei uns die Möglichkeit, den Job vorab hautnah zu erleben. So weißt du am Ende genau, worauf du dich einlässt. Plane für den gesamten Prozess 2 Wochen ein.',
    items: [
      {
        icon: {
          src: 'de/Apply/ico-application.svg'
        },
        text:
          '<strong>Bewerbung:</strong> Bewirb dich einfach und unkompliziert mit deinem Lebenslauf oder deinem aktuellen LinkedIn-Profil. Ein Anschreiben brauchst du nicht.'
      },
      {
        icon: {
          src: 'de/Apply/ico-phone.svg'
        },
        text:
          '<strong>Erstes Interview:</strong> Zunächst führst du ein ca. 30-minütiges Kennenlerngespräch per Telefon oder Video mit einer:einem unserer Recruiter:innen. Dabei sprechen wir über die Rolle als Sales Consultant und deine bisherige Erfahrung.'
      },
      {
        icon: {
          src: 'de/Apply/ico-laptop.svg'
        },
        text:
          '<strong>Zweites Interview:</strong> Anschließend hast du ein Gespräch mit einer:einem unserer Teamleiter:innen. Hier gehen wir besonders auf deine Vertriebserfahrung und deine Motivation ein. Im Anschluss bekommst du von uns ausführliches Feedback.'
      },
      {
        icon: {
          src: 'de/Apply/ico-convo.svg'
        },
        text:
          '<strong>Einblick in den Job und drittes Interview:</strong> Du schaust einem unserer Sales Consultants direkt bei der Arbeit über die Schulter – auch per Video-Call möglich. Danach führst du ein finales Gespräch mit unserem Senior Sales Leadership.'
      },
      {
        icon: {
          src: 'de/Apply/ico-contract.svg'
        },
        text:
          '<strong>Angebot und Vertragsabschluss:</strong> Alles hat geklappt. Eine/r unserer Recruiter:innen meldet sich bei dir, um dir die frohe Nachricht zu überbringen und mit dir alle Vertragsdetails zu besprechen.'
      }
    ],
    ctas: [
      {
        text: 'Sales Consultant in Berlin »',
        link: 'https://job-boards.greenhouse.io/audibenehearcom/jobs/7950095'
      },
      {
        text: 'Sales Consultant in Mainz »',
        link: 'https://job-boards.greenhouse.io/audibenehearcom/jobs/7950109'
      },
      {
        text: 'Sales Consultant deutschlandweit »',
        link: 'https://job-boards.greenhouse.io/audibenehearcom/jobs/7950268'
      }
    ]
  },
  applyCampaign: {
    title: 'Bewerben bei audibene: In nur 5 Schritten zum Traumjob',
    text:
      'Unser Ziel ist es, die besten Kundenberater:innen in ganz Deutschland zu finden! Deshalb nehmen wir uns gerne besonders viel Zeit für dich und deine Bewerbung. Du erhältst nach jedem Schritt ausführliches Feedback von uns. Insgesamt solltest du ca. 3 Wochen für den gesamten Prozess einplanen.',
    items: [
      {
        icon: {
          src: 'de/Apply/ico-application.svg'
        },
        text:
          '<strong>Bewerbung:</strong> Bewirb dich einfach und unkompliziert mit deinem Lebenslauf oder deinem XING oder LinkedIn Profil. Ein Anschreiben ist dabei nicht notwendig.'
      },
      {
        icon: {
          src: 'de/Apply/ico-phone.svg'
        },
        text:
          '<strong>Erstes Interview:</strong> Zunächst hast du ein ca. 30-minütiges Kennenlerngespräch per Telefon oder Video mit einem unserer Recruiter bzw. mit einer unserer Recruiter:innen. Dabei besprechen wir die Rolle des Kundenberaters/ der Kundenberaterin und deine bisherige Erfahrung.'
      },
      {
        icon: {
          src: 'de/Apply/ico-laptop.svg'
        },
        text:
          '<strong>Zweites Interview:</strong> Anschließend hast du ein Gespräch mit einem/r unserer Teamleiter:innen. Hier gehen wir besonders auf deine Vertriebserfahrung und Motivation ein.'
      },
      {
        icon: {
          src: 'de/Apply/ico-convo.svg'
        },
        text:
          '<strong>Einblicke in den Job und Drittes Interview</strong> Zuletzt erhältst du die Möglichkeit, hautnah dabei zu sein und einem unserer Kundenberatern oder Kundenberaterinnen über die Schulter zu schauen. Anschließend wirst du ein finales Gespräch mit unserem Senior Sales Leadership führen.'
      },
      {
        icon: {
          src: 'de/Apply/ico-contract.svg'
        },
        text:
          '<strong>Angebot und Vertragsabschluss:</strong> Alles hat geklappt. Eine/r unserer Recruiter:innen meldet sich bei dir, um dir die frohe Nachricht zu überbringen und mit dir alle Vertragsdetails zu besprechen.'
      }
    ]
  },
  homeOffice: {
    title: 'Erfolgreich im Home Office',
    blocks: [
      {
        text:
          'Arbeiten aus dem Home Office ist bei uns im Sales von Anfang an möglich. Wer nicht in der Nähe unserer Standorte in Berlin oder Mainz lebt, arbeitet dauerhaft von zuhause – das sind rund 80 % unseres Sales Teams. Mit modernster Videokommunikation (Zoom) und cloudbasierter CRM-Software (Salesforce) bist du dabei voll angebunden.'
      },
      {
        text:
          'Team-orientiertes Arbeiten ist uns sehr wichtig. Dazu bist du täglich mit deinen Kolleg:innen über Videotelefonie in Kontakt. Zusätzlich veranstalten wir jedes Quartal ein Teamevent und zwei bis dreimal im Jahr Partys und Ausflüge, bei denen du deine Kolleg:innen auch persönlich triffst.'
      }
    ]
  },
  carouselSales: {
    title: 'Einarbeitung, Weiterentwicklung und Coaching',
    textBlocks: [
      {
        text:
          'Für uns ist Weiterentwicklung ein wichtiger Teil unserer Firmenkultur. Alle in unserem Team möchten einen guten Job machen und sich dabei konstant verbessern.'
      },
      {
        text:
          'Das fängt mit Herausforderungen im Job an: Die Vielfältigkeit unserer Kund:innen erfordert, dass man sich immer wieder neu an verschiedene Persönlichkeiten anpassen muss und seinen Vertriebsstil weiterentwickelt. Dabei unterstützen wir dich.'
      }
    ],
    slides: [
      {
        img: {
          mobile: 'de/Coaching/coaching_1_mobile.jpg',
          desktop: 'de/Coaching/coaching_1_desktop.jpg'
        },
        title: 'Einarbeitung und Coaching',
        text:
          'Unsere Sales Academy begleitet dich von Anfang an: Sie verantwortet deine strukturierte Einarbeitung in den ersten zwei Monaten und führt danach regelmäßig Vertriebstrainings durch. Erfahrene Sales Coaches stehen dir außerdem im individuellen Coaching zur Seite.'
      },
      {
        img: {
          mobile: 'de/Coaching/coaching_2_mobile.jpg',
          desktop: 'de/Coaching/coaching_2_desktop.jpg'
        },
        title: 'Entwicklungsstufen und Rollenwechsel',
        text:
          'Gute Leistung zahlt sich bei uns aus – finanziell und mit mehr Verantwortung. Unsere Entwicklungsstufen sind klar definiert: Vom Sales Consultant über Senior und Expert bis zur Stufe Diamant. Wer zusätzlich bereichsübergreifend Erfahrung sammeln möchte, kann über unser 4+1-Modell einen Tag pro Woche in einem anderen Team mitarbeiten.'
      }
    ]
  },
  audibeneKultur: {
    title: 'Lerne unser Team kennen',
    items: [
      {
        img: 'de/Kultur/portrait_03.jpg',
        innerTitle: 'Johannes',
        innerSubtitle: 'Expert Customer Sales Consultant',
        innerCopy:
          '„Ich bin seit 2015 bei audibene und mir macht es jeden Tag aufs Neue Spaß Menschen zum Thema besser Hören zu unterstützen, damit diese wieder besser am aktuellen Leben teilnehmen können. Ich stehe als Kundenberater für alle Fragen zum Thema Hörgeräte immer gerne zur Verfügung.“​'
      },
      {
        img: 'de/Kultur/portrait_04.jpg',
        innerTitle: 'Julia',
        innerSubtitle: 'Expert Customer Sales Consultant',
        innerCopy:
          '„An meinem Job gefällt mir besonders, dass man jeden Tag ganz besondere Menschen kennenlernt. Man hört interessante Geschichten, man lacht mit den Kund:innen – manchmal weint man auch mit ihnen.“​'
      },
      {
        img: 'de/Kultur/portrait_05.jpg',
        innerTitle: 'Helena',
        innerSubtitle: 'Expert Customer Sales Consultant',
        innerCopy:
          '„Ich habe bei audibene etwas gefunden, das ich wirklich gerne vertreibe. Es ist nicht einfach der nächste Vertriebsjob, sondern ich kann hinter dem Produkt Hörgerät stehen, das einen Mehrwert für unsere Kund:innen im Alltag und im Leben schafft.“​'
      }
    ]
  },
  salesContact: {
    title: 'Du hast noch Fragen?',
    text:
      'Wir sind jederzeit für dich da!<br />E-Mail: jobs@audibene.de',
    contacts: []
  },

  //internship page
  internHero: {
    img: {
      desktop: 'de/Hero/hero-audibene-de-terrace-d.jpg',
      mobile: 'de/Hero/hero-audibene-de-terrace-m.jpg'
    },
    title: 'Werde Teil unseres Teams',
    subtitle: 'Verändere mit uns die Zukunft des Hörens und booste deine Karriere!',
    cta: {
      text: 'Jetzt bewerben!',
      anchor: 'jobs'
    }
  },
  internWhatAwaits: {
    title: 'Das erwartet dich bei audibene',
    items: [
      {
        icon: 'de/Values/responsibility.svg',
        title: 'Eigenverantwortung',
        text:
          'Nimm die Dinge selbst in die Hand und trage die Verantwortung für deine eigenen Projekte.'
      },
      {
        icon: 'de/TalentProgram/party_final.svg',
        title: 'Benefits',
        text: 'Profitiere von Angeboten wie Mittagessen, Sport und Rabatten.'
      },
      {
        icon: 'de/TalentProgram/holding_hands.svg',
        title: 'Team of Teams',
        text: 'Erhalte umfassende Einblicke in unser Business und lerne von verschiedenen Teams.'
      },
      {
        icon: 'de/TalentProgram/globe.svg',
        title: 'Tolle Projekte',
        text: 'Arbeite an internationalen Projekten in einem globalen Healthtech Unternehmen.'
      },
      {
        icon: 'de/TalentProgram/ear_final.svg',
        title: 'Job mit Sinn',
        text: 'Verändere mit uns gemeinsam das Leben von Menschen durch besseres Hören.'
      }
    ]
  },
  aboutIntern: {
    title: 'audibene ist ein Ort zum Wachsen & Lernen',
    blocks: [
      {
        text:
          'Unsere Praktikant:innen und Werkstudent:innen sind ein wertvoller Teil unseres Teams. Bei audibene stellen wir sicher, dass du durch die Arbeit an sinnvollen Aufgaben einen Einfluss auf das Unternehmen hast und fördern deine persönliche und deine berufliche Entwicklung.'
      },
      {
        text:
          'Schluss mit der Theorie – jetzt ist es an der Zeit, deine Fähigkeiten zu zeigen und diese in die Praxis umzusetzen. Du wirst mitten im Zentrum wichtiger Unternehmensprojekte stehen und mit einem motivierten, internationalen Team zusammenarbeiten.'
      }
    ]
  },

  talentProgram: {
    title: 'Entfalte dein Potenzial im audibene Future Talent Programm',
    blocks: [
      {
        img: {
          desktop: 'de/TalentProgram/intern_01.jpg',
          mobile: 'de/TalentProgram/intern_01.jpg'
        },
        textBlock: {
          title: 'Habe von Tag 1 an Einfluss auf unser Business',
          text:
            'Du arbeitest an sinnvollen Aufgaben und Projekten bei denen du eigenverantwortlich einen Beitrag leistest. Dadurch bist du ein vollwertiges Teammitglied.'
        }
      },
      {
        img: {
          desktop: 'de/TalentProgram/intern_02.jpg',
          mobile: 'de/TalentProgram/intern_02.jpg'
        },
        textBlock: {
          title: 'Entwickle dich persönlich & professionell weiter',
          text:
            'Du kannst an regelmäßig stattfindenden Trainings und Workshops teilnehmen. Durch Feedback auf Augenhöhe definierst du einen Entwicklungsplan gemeinsam mit deiner Teamleitung.'
        }
      },
      {
        img: {
          desktop: 'de/TalentProgram/intern_03.jpg',
          mobile: 'de/TalentProgram/intern_03.jpg'
        },
        textBlock: {
          title: 'Lerne ein globales Healthtech Unternehmen kennen',
          text:
            'Durch die Teilnahme an gemeinsamen Lunch & Learning Sessions mit erfahrenen Team-Mitgliedern erhältst du einen umfangreichen Einblick in das Unternehmen und in den Arbeitsalltag verschiedener Teams.'
        }
      },
      {
        img: {
          desktop: 'de/TalentProgram/intern_04.jpg',
          mobile: 'de/TalentProgram/intern_04.jpg'
        },
        textBlock: {
          title: 'Werde Teil eines hochmotivierten, internationalen Teams',
          text:
            'Interessante Veranstaltungen und zahlreiche Events helfen dir dabei, schnell Kontakte zu knüpfen und dich mit anderen Teams auszutauschen.'
        }
      }
    ]
  },

  internCarousel: {
    title: 'Lerne unsere Future Talents kennen',
    slides: [
      {
        img: {
          mobile: 'de/Carousel/Michelle_m.jpg',
          desktop: 'de/Carousel/Michelle_d.jpg'
        },
        title: 'Michelle',
        subtitle: 'Working Student Talent Acquisition',
        text:
          '„Ich habe damals mit einem Praktikum in der Talent Acquisition bei audibene begonnen. Im Anschluss wurde ich als Werkstudentin übernommen. Seitdem betreue ich verschiedenste Projekte alleine oder auch gemeinsam mit meinem Team und bekomme seit meinem Start bei audibene viel Eigenverantwortung und Entscheidungsfreiheiten.“'
      },
      {
        img: {
          mobile: 'de/Carousel/jorge_m.jpg',
          desktop: 'de/Carousel/jorge_d.jpg'
        },
        title: 'Jorge',
        subtitle: 'Intern Performance Marketing to Performance Marketing Manager',
        text:
          '„Sowohl als Praktikant als auch jetzt als Performance Marketing Manager bei audibene genieße ich die Vielfalt der Aufgaben, die ich bekomme. Es ist nie langweilig! Ich erhalte Vertrauen, Freiheit und Unterstützung, wenn ich Entscheidungen treffe. Ich bewundere auch die Professionalität der Menschen, mit denen ich zusammenarbeite. Wir tauschen oft Ideen und unterschiedliche Perspektiven aus, es gibt Raum für Kreativität und Lernen – das wird mich in meiner beruflichen Laufbahn prägen.“'
      },
      {
        img: {
          mobile: 'de/Carousel/lara_m.jpg',
          desktop: 'de/Carousel/lara_d.jpg'
        },
        title: 'Lara',
        subtitle: 'Product Management Intern to Product Manager Contact Center',
        text:
          '„Ich schätze die Unternehmenskultur sehr, vor allem, weil offene Kommunikation und gegenseitige Unterstützung im Mittelpunkt stehen. Es gibt ein starkes Gefühl von Respekt und Vertrauen, und jeder hat die Möglichkeit, seine Meinung in einem geschützten Rahmen zu äußern. Außerdem finde ich es motivierend, Teil der positiven Mission des Unternehmens zu sein und das Leben der Menschen durch besseres Hören zu verändern.“'
      }
    ]
  },
  internApply: {
    title: 'Unser Bewerbungsprozess',
    items: [
      {
        icon: {
          src: 'de/Apply/ico-application.svg'
        },
        text:
          '<strong>Lass uns gemeinsam herausfinden, ob wir gut zusammenpassen</strong><br>Bewirb dich mit deinem Lebenslauf oder deinem LinkedIn Profil. Ein Anschreiben ist nicht nötig.'
      },
      {
        icon: {
          src: 'de/Apply/ico-phone.svg'
        },
        text:
          '<strong>Recruiter:innen Gespräch: Lerne audibene kennen</strong><br>In diesem ersten Gespräch werden wir über deine Erfahrung und Motivation sprechen. Wir beantworten all deine Fragen rund um audibene und zu der Position, auf die du dich bewirbst.'
      },
      {
        icon: {
          src: 'de/Apply/ico-laptop.svg'
        },
        text:
          '<strong>Interviews: Triff dein zukünftiges Team</strong><br>Dieses Gespräch ist eine tolle Möglichkeit, uns dein Interesse und Können zu zeigen! Außerdem wirst du mehr über dein Team erfahren, die Themen, an denen wir gemeinsam arbeiten und unsere Erwartungen an dich.'
      },
      {
        icon: {
          src: 'de/Apply/ico-contract.svg'
        },
        text:
          '<strong>Offer Call: Lass uns die Dinge offiziell machen</strong><br>Dies ist der letzte Schritt in unserem Prozess. Wir besprechen die finalen Details, finden heraus ob es für beide Seiten passt und starten unseren gemeinsamen Weg!'
      }
    ]
  },
  internTipps: {
    title: 'Tipps für deine Bewerbung',
    items: [
      {
        icon: {
          color: '#A0CFEB'
        },
        text:
          '<b>Achte auf Struktur & klare Formulierungen:</b> Ziehe deinen Lebenslauf nicht in die Länge und gib uns stattdessen lieber einen Einblick in deine relevante Erfahrung (Portfolio etc.). Versuche im Gespräch deine Punkte mit Beispielen zu illustrieren und hebe deine Fähigkeiten, sowie deine bisherige Erfahrung in deiner strukturierten Antwort hervor.'
      },
      {
        icon: {
          color: '#6AADE4'
        },
        text:
          '<b>Informiere dich über audibene:</b> Recherchiere zur Geschichte von audibene und bekomme ein besseres Verständnis dafür, wie wir arbeiten. Nützliche Quellen hierfür sind unsere <a href="https://karriere.audibene.de/?lang=de" target="_blank">Karriereseite</a> und unser <a href="https://www.instagram.com/inside.audibene/" target="_blank">@inside.audibene</a> Instagram account.'
      },
      {
        icon: {
          color: '#00549F'
        },
        text:
          '<b>Zeig uns deine Motivation, Teil von audibene zu werden:</b> Wir sind davon überzeugt, dass gutes Hören glücklich macht. Unser Ziel ist es, ein Team aufzubauen, das diese Mission und unsere Werte teilt.'
      },
      {
        icon: {
          color: '#21314D'
        },
        text:
          '<b>Wir möchten dich kennenlernen:</b> Zeig uns, wer du bist und verrate uns, auf welche Weise du unser Team bereichern kannst. Wir sehen Hiring nicht als Einbahnstraße – habe daher keine Scheu, uns deine Fragen zu stellen und finde heraus, ob auch wir zu dir passen.'
      }
    ]
  },

  internFAQ: {
    title: 'Willst du noch mehr wissen?',
    items: [
      {
        title: 'Welche Stellen gibt es für Future Talents?',
        text:
          'Egal, was du studierst, oder ob du gerade deinen Abschluss gemacht hast — wir haben alle Arten von Praktika im Angebot: Positionen als Werkstudent:in, freiwilliges Praktikum, genauso wie Pflichtpraktika. Jeweils von 3-6 Monaten. Such dir etwas aus  — audibene ist der Ort zum Wachsen und Lernen!'
      },
      {
        title: 'Ist ein Praktikum bei audibene bezahlt?',
        text:
          'Ja! Da wir deinen Beitrag sehr schätzen, belohnen wir diesen auch mit einem angemessenen Gehalt.'
      },
      {
        title: 'Wer kann am Future Talent Programm teilnehmen?',
        text:
          'Studierende, die an einer deutschen Universität eingeschrieben sind und Absolvent:innen bis zu einem Jahr nach dem Abschluss.'
      },
      {
        title: 'Findet das Praktikum remote oder in Berlin statt?',
        text:
          'Als Future Talent arbeitest du bei uns überwiegend vor Ort in unserem Berliner Headquarter. So bist du mitten im Geschehen, lernst von erfahrenen Kolleg:innen und baust dir von Anfang an ein Netzwerk auf.'
      }
    ]
  },
  internJobs: {
    title: 'Bewirb dich jetzt!'
  },
  internContact: {
    text:
      '… oder melde dich bei <a href="https://www.linkedin.com/in/nadja-reihofer/" target="_blank">Nadja</a> auf LinkedIn!',
    contacts: [
      {
        img: 'de/TalentProgram/Nadja.jpg',
        name: 'Nadja Reihofer',
        position: 'Talent Acquisition Manager'
      }
    ]
  }
};

export default data;
